import { render, staticRenderFns } from "./SpecialistBanList.vue?vue&type=template&id=d851e4b4&scoped=true&"
import script from "./SpecialistBanList.vue?vue&type=script&lang=js&"
export * from "./SpecialistBanList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d851e4b4",
  null
  
)

export default component.exports